import Vue from 'vue'
import Router from 'vue-router'

import PaymentCreator from '@/views/PaymentCreator/PaymentCreator'
import PaymentStepPlan from '@/views/PaymentCreator/PaymentStepPlan'
import PaymentStepPeriod from '@/views/PaymentCreator/PaymentStepPeriod'
import PaymentStepExtra from '@/views/PaymentCreator/PaymentStepExtra'
import PaymentStepSummary from '@/views/PaymentCreator/PaymentStepSummary'

import AfterPayment from '@/views/AfterPayment/AfterPayment'
import CanceledPaymentRedirect from '@/views/AfterPayment/CanceledPaymentRedirect'
import JwtSession from '@/views/JwtSession/JwtSession'

import auth from '@/auth'
import store from '@/store'

Vue.use(Router)

function wizardBeforeEnter (to, from, next) {
  store.commit('setStep', to.meta.step)
  if (store.state.loadingCreatorData && ([2, 3].includes(to.meta.step) || (to.meta.step === 4 && !to.params.plan && !to.params.period))) {
    next({ name: 'PaymentStepPlan' })
  } else {
    if (store.state.loadingCreatorData) {
      store.dispatch('fetchConfig')
      store.dispatch('fetchCreatorData')
    }
    next()
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'PaymentStepPlan' }
    },
    {
      path: '/krok',
      component: PaymentCreator,
      children: [
        {
          path: '',
          redirect: { name: 'PaymentStepPlan' }
        },
        {
          path: 'plan/:current_plan?',
          component: PaymentStepPlan,
          name: 'PaymentStepPlan',
          meta: {
            auth: true,
            title: 'Wybierz plan',
            step: 1
          },
          beforeEnter: wizardBeforeEnter
        },
        {
          path: 'okres',
          component: PaymentStepPeriod,
          name: 'PaymentStepPeriod',
          meta: {
            auth: true,
            title: 'Wybierz okres',
            step: 2
          },
          beforeEnter: wizardBeforeEnter
        },
        {
          path: 'extra',
          component: PaymentStepExtra,
          name: 'PaymentStepExtra',
          meta: {
            auth: true,
            title: 'Wybierz dodatki',
            step: 3
          },
          beforeEnter: wizardBeforeEnter
        },
        {
          path: 'podsumowanie',
          component: PaymentStepSummary,
          name: 'PaymentStepSummary',
          meta: {
            auth: true,
            title: 'Podsumowanie',
            step: 4
          },
          beforeEnter: wizardBeforeEnter
        },
        {
          path: 'podsumowanie/:plan(basic|master|premium|vip)/:period(1|6|12|24)/:code?',
          component: PaymentStepSummary,
          name: 'PaymentStepSummaryWithParams',
          meta: {
            auth: true,
            title: 'Podsumowanie',
            step: 4
          },
          beforeEnter: wizardBeforeEnter
        },
        {
          path: '*',
          redirect: { name: 'PaymentStepPlan' }
        }
      ]
    },
    {
      path: '/podsumowanie/:orderId',
      component: AfterPayment,
      name: 'AfterPayment',
      meta: {
        title: 'Podsumowanie'
      }
    },
    {
      path: '/expired/',
      component: CanceledPaymentRedirect,
      name: 'CanceledPaymentRedirect',
      meta: {
        title: 'Twój link wygasł'
      }
    },
    {
      path: '/session/:token/:path',
      component: JwtSession
    }
  ]
})

router.beforeEach((to, from, next) => {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
  const hasUtmParams = utmParams.some(param => to.query[param])
  let queryChanged = false

  if (hasUtmParams) {
    utmParams.forEach(param => {
      if (to.query[param]) {
        localStorage.setItem(param, to.query[param])
      } else {
        localStorage.removeItem(param)
      }
    })
  } else {
    utmParams.forEach(param => {
      const value = localStorage.getItem(param)
      if (value) {
        to.query[param] = value
        queryChanged = true
      }
    })
  }

  if (to.meta.auth) {
    auth.checkToken(encodeURIComponent(to.path))
  }
  if (to.meta.title) {
    document.title = process.env.VUE_APP_TITLE_PREFIX + to.meta.title + ' - ' + process.env.VUE_APP_TITLE
  } else {
    document.title = process.env.VUE_APP_TITLE_PREFIX + process.env.VUE_APP_TITLE
  }

  if (queryChanged) {
    next(to)
  } else {
    next()
  }
})

export default router
